import React from 'react';
import Button from 'react-gazelle/lib/components/Button';
import Heading, { TAGS } from 'react-gazelle/lib/components/Heading';
import Radio from '../radio';

const InlineForm = ({
  title,
  submitText,
  questions,
  destinations,
  handleChange,
  formIncomplete
}) => (
  <div>
    <figure className="gzl-DataTable u-spacingStack2">
      {title ? (
        <figcaption className="gzl-DataTable-title u-spacingStack4">
          <Heading tag={TAGS.H2} secondary>
            {title}
          </Heading>
        </figcaption>
      ) : null}

      <table>
        <thead>
          <tr>
            <th>Question</th>

            {destinations.map((destination) => (
              <th key={destination.name} className="u-textAlignCenter">
                {destination.label}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {questions.map((question, index) => (
            <tr key={question.name}>
              <td className="UserRoutingSurvey-question UserRoutingSurvey-question--inline">
                <div className="UserRoutingSurvey-questionNumber UserRoutingSurvey-questionNumber--inline">
                  {index + 1}.
                </div>
                <div className="UserRoutingSurvey-questionText">
                  {question.text}
                </div>
              </td>

              {destinations.map((destination) => (
                <td key={destination.name} className="u-textAlignCenter">
                  <Radio
                    id={`${question.name}-option-${destination.name}`}
                    labelClassName="UserRoutingSurvey-radioLabel"
                    name={question.name}
                    value={destination.name}
                    onChange={handleChange}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </figure>

    <p className="u-textAlignCenter">
      <Button
        id="user-routing-survey-submit"
        type="submit"
        disabled={formIncomplete}
      >
        {submitText}
      </Button>
    </p>
  </div>
);

export default InlineForm;
